import { F4SummarySVG } from "./SVGIllustrations";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { classifyDiet, classifyBehavior } from "./helpers";

export default function Step6Summary({
  dietScore, behaviorScore, hydrationCat,
  nivelMotivacion, motivaciones, restricciones, restriccionOtra,
}) {
  const dietClass = classifyDiet(dietScore);
  const behaviorClass = classifyBehavior(behaviorScore);

  return (
    <div>
      <F4SummarySVG complete={true} />

      <p className="text-xs text-center mb-4 font-medium" style={{ color: "#71644C" }}>
        Resumen de tu evaluación nutricional
      </p>

      <CalculatedBadge
        label="Calidad de dieta"
        value={`${dietScore}/40`}
        category={dietClass.label}
        categoryColor={dietClass.color}
        testId="summary-calidad-dieta"
      />
      <CalculatedBadge
        label="Conductas alimentarias"
        value={`${behaviorScore}/15`}
        category={behaviorClass.label}
        categoryColor={behaviorClass.color}
        testId="summary-conductas"
      />
      {hydrationCat && (
        <CalculatedBadge
          label="Hidratación"
          value={hydrationCat.category}
          categoryColor={hydrationCat.color}
          testId="summary-hidratacion"
        />
      )}
      <CalculatedBadge
        label="Motivación"
        value={nivelMotivacion || "—"}
        categoryColor="#157346"
        testId="summary-motivacion"
      />

      {/* Goals list */}
      {motivaciones.length > 0 && (
        <div className="mb-3 rounded-[14px] p-3" style={{ background: "#FCFAEE", border: "1px solid #E2D9CB" }} data-testid="summary-goals">
          <p className="text-[11px] font-semibold uppercase tracking-wide mb-1.5" style={{ color: "#71644C" }}>Objetivos</p>
          <div className="flex flex-wrap gap-1.5">
            {motivaciones.map((m) => (
              <span key={m} className="text-[10px] px-2 py-0.5 rounded-md font-semibold" style={{ background: "#E2F0E8", color: "#157346" }}>{m}</span>
            ))}
          </div>
        </div>
      )}

      {/* Restrictions list */}
      <div className="mb-3 rounded-[14px] p-3" style={{ background: "#FCFAEE", border: "1px solid #E2D9CB" }} data-testid="summary-restrictions">
        <p className="text-[11px] font-semibold uppercase tracking-wide mb-1.5" style={{ color: "#71644C" }}>Restricciones</p>
        <p className="text-xs" style={{ color: "#2D2A24" }}>
          {restricciones.length === 0
            ? "Ninguna"
            : restricciones.map((r) => r === "Otra" ? `Otra: ${restriccionOtra}` : r).join(", ")}
        </p>
      </div>

      <div
        className="rounded-xl p-3 mt-3 text-center"
        style={{ background: "#E2F0E8" }}
        data-testid="f4-ready-message"
      >
        <span className="text-[13px] font-semibold" style={{ color: "#157346" }}>
          ¡Listo! Envía tu evaluación nutricional.
        </span>
      </div>
    </div>
  );
}
